
import { Component, Vue, Watch } from 'vue-property-decorator';
import actions from '@/shared/actions';
import Topbar from '@/components/topbar/index.vue';
import AppUserBar from '@/components/appUserBar/index.vue';
import { useUserInfo } from '@/hooks/useUserInfo';
import dayjs from 'dayjs';

@Component({
  components: {
    Topbar,
    AppUserBar
  }
})
export default class App extends Vue {
  private showTopbar: boolean = false;
  private isHome: boolean = false;
  private watermarkText: string = '';
  private isNewThemeApp: boolean = false;

  private isShowMistoreTheme: boolean = false;
  private isShowPartnerTheme: boolean = false;

  private globalTheme: string = '';

  @Watch('$route', { immediate: true, deep: true })
  onRouteNameChange(newVal: any /** Route */) {
    this.showTopbar = newVal.path !== '/login';
    this.isHome = newVal.path === '/';
    console.log(newVal);
    this.isNewThemeApp = !newVal.path.includes('main-taskcenter');

    this.isShowMistoreTheme = newVal.path.includes('main-mistore');
    this.isShowPartnerTheme = newVal.path.includes('main-retailrevolution-partner');

    // 如果是 partner 主题，获取用户信息
    // if (this.isShowPartnerTheme) {
    //   this.fetchUserInfoForPartner();
    // }

    if (this.isShowMistoreTheme) {
      this.globalTheme = 'qk-newtheme qk-global-theme';
    } else if (this.isNewThemeApp) {
      this.globalTheme = 'qk-newtheme';
    } else {
      this.globalTheme = '';
    }
  }

  /**
   * 为 partner 主题获取用户信息
   */
  async fetchUserInfoForPartner() {
    const { getUserInfo } = useUserInfo(this.$router);
    await getUserInfo();
  }

  mounted() {
    // 页面初始化时，如果是 partner 主题，获取用户信息
    if (this.isShowPartnerTheme) {
      this.fetchUserInfoForPartner();
    }

    actions.onGlobalStateChange((state) => {
      console.log('App.vue onGlobalStateChange:', state);
      // 监听子应用传递的 shadowOriginMid 和 shadowUserId
      // 如果这两个值都有值，并且 isShowPartnerTheme，则使用新的格式
      if (
        this.isShowPartnerTheme
      ) {
        // 使用 dayjs 格式化日期为 YYYY-MM-DD
        const dateStr = dayjs().format('YYYY-MM-DD');
        
        // 如果 shadowOriginMid 和 shadowUserId 都有值，使用新格式
        if (state.shadowOriginMid && state.shadowUserId) {
          this.watermarkText = `零售通PC\n${state.shadowOriginMid}/${state.shadowUserId}\n${dateStr}`;
        } else {
          this.watermarkText = `零售通PC\n${state.userInfo?.account}\n${dateStr}`;
        }
      } else if (state.userInfo) {
        this.watermarkText = `${state.userInfo.userName}  ${state.userInfo.mobile.slice(-4)}`;
      }
    }, true);
  }
}
